import { 
  width, 
  height, 
  padding,
  display,
  background,
  fontSize,
} from "../styling/responsiveProp";

export const globalResponsiveProps = [
  width,
  height,
  padding,
  display,
  background,
  fontSize,
];
